import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import classNames from 'classnames';
import styles from './ModalWithExternalHeader.css';

function CustomDialog(props) {
  const { externalHeaderText, style, children } = props;
  const modalStyle = { display: 'block', ...style };
  return (
    <div
      className="fade in modal"
      tabIndex="-1"
      role="dialog"
      style={modalStyle}
    >
      <div
        className={classNames('modal-dialog', styles.dialog)}
        role="document"
      >
        <div className={styles.externalHeader}>{externalHeaderText}</div>
        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
}

function ModalWithExternalHeader(props) {
  return <Modal {...props} dialogComponentClass={CustomDialog} />;
}

ModalWithExternalHeader.defaultProps = {
  externalHeaderText: '',
};

ModalWithExternalHeader.propTypes = {
  externalHeaderText: PropTypes.string,
};

export default ModalWithExternalHeader;
